import React, { useState } from 'react';
import vocabularyData from '../data/vocabulary.json';

const GRADES = [
  { value: 1, label: '一年级' },
  { value: 2, label: '二年级' },
  { value: 3, label: '三年级' },
  { value: 4, label: '四年级' },
  { value: 5, label: '五年级' },
  { value: 6, label: '六年级' },
];

function VocabularyPicker({ onSelect, onClose }) {
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);

  // 获取当前选中册别的数据
  const currentBook = selectedGrade !== null && selectedSemester !== null
    ? vocabularyData.find(
        v => v.grade === selectedGrade && v.semester === selectedSemester
      )
    : null;

  const lessons = currentBook?.lessons || [];
  const selectedGradeLabel = GRADES.find(item => item.value === selectedGrade)?.label || '';

  const handleGradeClick = (grade) => {
    setSelectedGrade(grade);
    setSelectedSemester(null);
    setSelectedLesson(null);
  };

  const handleSemesterClick = (semester) => {
    setSelectedSemester(semester);
    setSelectedLesson(null);
  };

  const handleLessonClick = (lesson) => {
    setSelectedLesson(lesson);
  };

  const handleConfirm = (mode = 'replace') => {
    if (selectedLesson && selectedLesson.words.length > 0) {
      onSelect(selectedLesson.words, mode, {
        grade: selectedGrade,
        gradeLabel: selectedGradeLabel,
        semester: selectedSemester,
        lessonId: selectedLesson.id,
        all: false,
      });
    }
  };

  const handleConfirmAll = (mode = 'replace') => {
    if (currentBook && currentBook.lessons.length > 0) {
      const allWords = currentBook.lessons.flatMap(l => l.words);
      if (allWords.length > 0) {
        onSelect(allWords, mode, {
          grade: selectedGrade,
          gradeLabel: selectedGradeLabel,
          semester: selectedSemester,
          all: true,
        });
      }
    }
  };

  return (
    <>
      {/* 遮罩层 */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1000,
        }}
        onClick={onClose}
      />

      {/* 选择器面板 */}
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '560px',
          maxHeight: '80vh',
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          zIndex: 1001,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* 标题栏 */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>
            选择词语表
          </span>
          <button
            onClick={onClose}
            style={{
              border: 'none',
              background: 'none',
              fontSize: '18px',
              color: '#999',
              cursor: 'pointer',
              padding: '4px 8px',
            }}
          >
            x
          </button>
        </div>

        {/* 内容区 */}
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          {/* 年级列表 */}
          <div
            style={{
              width: '80px',
              borderRight: '1px solid #f0f0f0',
              overflowY: 'auto',
              padding: '8px 0',
            }}
          >
            {GRADES.map((grade) => (
              <div
                key={grade.value}
                onClick={() => handleGradeClick(grade.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '13px',
                  color: selectedGrade === grade.value ? '#1890ff' : '#333',
                  background: selectedGrade === grade.value ? '#e6f7ff' : 'transparent',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                {grade.label}
              </div>
            ))}
          </div>

          {/* 册别列表 */}
          <div
            style={{
              width: '80px',
              borderRight: '1px solid #f0f0f0',
              overflowY: 'auto',
              padding: '8px 0',
            }}
          >
            {selectedGrade !== null && ['上册', '下册'].map((sem) => {
              const book = vocabularyData.find(
                v => v.grade === selectedGrade && v.semester === sem
              );
              const wordCount = book ? book.lessons.reduce((s, l) => s + l.words.length, 0) : 0;
              return (
                <div
                  key={sem}
                  onClick={() => handleSemesterClick(sem)}
                  style={{
                    padding: '10px 12px',
                    fontSize: '13px',
                    color: selectedSemester === sem ? '#1890ff' : '#333',
                    background: selectedSemester === sem ? '#e6f7ff' : 'transparent',
                    cursor: 'pointer',
                    textAlign: 'center',
                  }}
                >
                  <div>{sem}</div>
                  <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
                    {wordCount}词
                  </div>
                </div>
              );
            })}
          </div>

          {/* 课文列表 */}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              padding: '12px',
            }}
          >
            {selectedSemester && lessons.length === 0 && (
              <div style={{ color: '#999', fontSize: '13px', textAlign: 'center', marginTop: '40px' }}>
                该册暂无词语数据
              </div>
            )}
            {lessons.map((lesson) => (
              <div
                key={lesson.id}
                onClick={() => handleLessonClick(lesson)}
                style={{
                  padding: '10px 12px',
                  marginBottom: '4px',
                  borderRadius: '6px',
                  border: selectedLesson?.id === lesson.id ? '1px solid #1890ff' : '1px solid #f0f0f0',
                  background: selectedLesson?.id === lesson.id ? '#f0f7ff' : 'white',
                  cursor: 'pointer',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                  第{lesson.id}课
                </div>
                <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.6' }}>
                  {lesson.words.join(' ')}
                </div>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                  {lesson.words.length} 个词语
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 底部操作栏 */}
        {currentBook && currentBook.lessons.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
              padding: '12px 20px',
              borderTop: '1px solid #f0f0f0',
            }}
          >
            <button
              onClick={() => handleConfirmAll('append')}
              style={{
                padding: '8px 16px',
                fontSize: '12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                background: 'white',
                cursor: 'pointer',
                color: '#666',
              }}
            >
              追加全册
            </button>
            <button
              onClick={() => handleConfirm('append')}
              disabled={!selectedLesson || selectedLesson.words.length === 0}
              style={{
                padding: '8px 16px',
                fontSize: '12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                background: 'white',
                cursor: selectedLesson ? 'pointer' : 'not-allowed',
                color: selectedLesson ? '#666' : '#bbb',
              }}
            >
              追加本课
            </button>
            <button
              onClick={() => handleConfirmAll('replace')}
              style={{
                padding: '8px 16px',
                fontSize: '12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                background: 'white',
                cursor: 'pointer',
                color: '#666',
              }}
            >
              替换全册 ({currentBook.lessons.reduce((s, l) => s + l.words.length, 0)}词)
            </button>
            <button
              onClick={() => handleConfirm('replace')}
              disabled={!selectedLesson || selectedLesson.words.length === 0}
              style={{
                padding: '8px 16px',
                fontSize: '12px',
                border: 'none',
                borderRadius: '4px',
                background: selectedLesson ? '#1890ff' : '#d9d9d9',
                color: 'white',
                cursor: selectedLesson ? 'pointer' : 'not-allowed',
              }}
            >
              导入本课 ({selectedLesson ? selectedLesson.words.length : 0}词)
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default VocabularyPicker;
